.mainPaper {
	min-width: 70vw;
	margin-left: 16px;
}

.seperatorLineBottom {
	margin-bottom: 20px !important;
}

.seperatorLine {
	margin-top: 20px !important;
	margin-bottom: 20px !important;
}

.displayFlex {
	display: flex;
}

.productContainer {
	width: 100% !important;
	text-align: center !important;
}

@media (max-width: 1919px) {
	.mainPaper {
		min-width: 55vw;
		flex: auto;
	}

	.shoppingCart {
		margin-right: 0;
		min-width: 40vw;
	}
}

@media (max-width: 1200px) {
	.mainPaper {
		min-width: 55vw;
		flex: auto;
		margin-left: 0px;
	}

	.shoppingCart {
		margin-right: 0;
		min-width: 30vw;
	}
}

@media (max-width: 820px) {
	.mainPaper {
		min-width: 100vw;
		margin-left: 0px;
		flex: auto;
	}
	.displayFlex {
		flex-direction: column !important;
	}
	.shoppingCart {
		margin-right: 0;
		min-width: 100vw;
	}
}

@media (max-width: 540px) {
	.mainPaper {
		min-width: 100vw;
		flex: auto;
		margin-left: 0px;
	}
	.displayFlex {
		flex-direction: column !important;
	}

	.shoppingCart {
		margin-right: 0;
		min-width: 100vw;
	}
}
